import type { ApiErrorBody, EnvelopeMeta } from './types';

/** Ошибка, пришедшая error-конвертом шлюза. */
export class ApiRequestError extends Error {
  override readonly name: string = 'ApiRequestError';

  constructor(
    readonly apiError: ApiErrorBody,
    readonly meta?: EnvelopeMeta,
  ) {
    super(apiError.message);
  }

  get code(): ApiErrorBody['code'] {
    return this.apiError.code;
  }

  get retryable(): boolean {
    return this.apiError.retryable;
  }

  get fieldErrors(): Record<string, string> {
    return this.apiError.fieldErrors ?? {};
  }
}

/**
 * version_conflict — типовое исключение для форм: форма ловит его отдельно
 * и предлагает перечитать объект (ConflictState), не «повторить».
 */
export class VersionConflictError extends ApiRequestError {
  override readonly name = 'VersionConflictError';
}

/** Сеть/шлюз недоступны или ответ не является конвертом. Всегда retryable. */
export class GatewayUnavailableError extends Error {
  override readonly name = 'GatewayUnavailableError';
  readonly retryable = true;

  constructor(
    message: string,
    override readonly cause?: unknown,
  ) {
    super(message);
  }
}
